var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33334 2.3335V7.3335V3.00016C9.33334 2.44788 9.78105 2.00016 10.3333 2.00016C10.8856 2.00016 11.3333 2.44788 11.3333 3.00016V7.3335V5.00016C11.3333 4.44788 11.7811 4.00016 12.3333 4.00016C12.8856 4.00016 13.3333 4.44788 13.3333 5.00016V10.6668C13.3333 12.876 11.5425 14.6668 9.33334 14.6668H8.58179C7.56555 14.6668 6.58741 14.28 5.84603 13.585L2.5403 10.4859C2.06243 10.0379 2.05026 9.28324 2.51344 8.82006C2.96626 8.36724 3.70042 8.36724 4.15323 8.82006L5.33334 10.0002V4.3335C5.33334 3.78121 5.78105 3.3335 6.33334 3.3335C6.88562 3.3335 7.33334 3.78121 7.33334 4.3335V7.3335V2.3335C7.33334 1.78121 7.78105 1.3335 8.33334 1.3335C8.88562 1.3335 9.33334 1.78121 9.33334 2.3335Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.8f5b852c5a242f151c557253d2993ed9.svg";
export { ForwardRef as ReactComponent };